import * as fileSaver from 'file-saver';
import { Component } from '@angular/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { getAlertMessage } from '../../../../shared/api-loaders';
import { getDownloadFileName } from '../../../../shared/StringHelper';
import { MessageService } from '../../../../shared/message.service';
import { ImportUsersService } from "../../../services/import-users.service";
import { EventEmitterWithObservable } from "../../../../shared/EventEmitterWithValueReturned";
import { MessageType } from '../../../../shared/messageType';
import { Alert } from '../../../../shared/alert.model';

@Component({
    selector: 're-import-users-list',
    templateUrl: './import-users-list.component.html',
    styleUrls: ['./import-users-list.component.scss'],
    standalone: false
})
export class ImportUsersListComponent {
  // Helpers
  alert: Alert;

  constructor(private importUsersService: ImportUsersService, private messageService: MessageService) { }

  load($event: EventEmitterWithObservable) {
    $event.ReturnValue = this.importUsersService.getTransactions();
  }

  download($event: any) {
    this.showSpinner();
    const processId = $event.processId;
    const customerName = $event.customerName;
    const crmId = $event.crmId;
    this.importUsersService.downloadImportsTemplate(processId).subscribe(x => {
      fileSaver.saveAs(x, getDownloadFileName("IdmCsvImport.csv"), x.type);
      this.hideSpinner();
    }, e => {
      this.hideSpinner();
      this.alert = getAlertMessage(e);
    });
  }

  private showSpinner(): void {
    this.messageService.send(MessageType.ProcessingOn);
  }

  private hideSpinner(): void {
    this.messageService.send(MessageType.ProcessingOff);
  }
}
